import { Routes } from '@angular/router';
import { authGuard, adminGuard, superAdminGuard, adminOrSuperAdminGuard, nonPrivilegedGuard } from './guards/auth.guard';
import { backOfficeGuard } from './guards/backoffice.guard';

export const routes: Routes = [
  // Back Office Routes (MUST be before other routes)
  {
    path: 'backoffice/login',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'backoffice/notes',
    canActivate: [backOfficeGuard],
    loadComponent: () => import('./pages/backoffice/backoffice-notes.component').then(m => m.BackOfficeNotesComponent)
  },
  {
    path: 'backoffice/bookings/:type/:id',
    canActivate: [backOfficeGuard],
    loadComponent: () => import('./pages/backoffice/backoffice-booking-detail.component').then(m => m.BackOfficeBookingDetailComponent)
  },
  {
    path: 'backoffice/bookings',
    canActivate: [backOfficeGuard],
    loadComponent: () => import('./pages/backoffice/backoffice-bookings.component').then(m => m.BackOfficeBookingsComponent)
  },
  {
    path: 'backoffice',
    redirectTo: 'backoffice/bookings',
    pathMatch: 'full'
  },
  
  // Regular routes
  {
    path: '',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/index/index.component').then(m => m.IndexComponent)
  },
  {
    path: 'payment/amount',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/payment-amount/payment-amount.component').then(m => m.PaymentAmountComponent)
  },
  {
    path: 'payment-callback',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/payment-callback/payment-callback.component').then(m => m.PaymentCallbackComponent)
  },
  {
    path: 'donation-success',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/donation-success/donation-success.component').then(m => m.DonationSuccessComponent)
  },
  {
    path: 'payment/result',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/payment-result/payment-result.component').then(m => m.PaymentResultComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'feedback',
    loadComponent: () => import('./pages/feedback/feedback.component').then(m => m.FeedbackComponent)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent)
  },
  {
    path: 'super-admin/admins',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./pages/admin-list/admin-list.component').then(m => m.AdminListComponent)
  },
  {
    path: 'super-admin/backoffice-users',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./pages/backoffice-users/backoffice-users.component').then(m => m.BackofficeUsersComponent)
  },
  {
    path: 'super-admin',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./pages/super-admin/super-admin.component').then(m => m.SuperAdminComponent)
  },
  {
    path: 'admin-management/:type',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/admin-management/admin-management.component').then(m => m.AdminManagementComponent)
  },
  {
    path: 'news-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/news-management/news-management.component').then(m => m.NewsManagementComponent)
  },
  {
    path: 'library-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/blog-management/blog-management.component').then(m => m.BlogManagementComponent)
  },
  {
    path: 'blog-management',
    redirectTo: 'library-management',
    pathMatch: 'full'
  },
  {
    path: 'announcements-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/announcements-management/announcements-management.component').then(m => m.AnnouncementsManagementComponent)
  },
  {
    path: 'partner-logos-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/partner-logos-management/partner-logos-management.component').then(m => m.PartnerLogosManagementComponent)
  },
  {
    path: 'support-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/support-management/support-management.component').then(m => m.SupportManagementComponent)
  },
  {
    path: 'home-banners-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/home-banners-management/home-banners-management.component').then(m => m.HomeBannersManagementComponent)
  },
  {
    path: 'news/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/news-detail/news-detail.component').then(m => m.NewsDetailComponent)
  },
  {
    path: 'library/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/blog-detail/blog-detail.component').then(m => m.BlogDetailComponent)
  },
  {
    path: 'blogs/:id',
    redirectTo: 'library/:id',
    pathMatch: 'full'
  },
  {
    path: 'news',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/news/news.component').then(m => m.NewsComponent)
  },
  {
    path: 'library',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/blogs/blogs.component').then(m => m.BlogsComponent)
  },
  {
    path: 'blogs',
    redirectTo: 'library',
    pathMatch: 'full'
  },
  {
    path: 'guides/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/guide-detail/guide-detail.component').then(m => m.GuideDetailComponent)
  },
  {
    path: 'guides',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/guides/guides.component').then(m => m.GuidesComponent)
  },
  {
    path: 'destinations/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/place-detail/place-detail.component').then(m => m.PlaceDetailComponent)
  },
  {
    path: 'places/:id',
    redirectTo: 'destinations/:id',
    pathMatch: 'full'
  },
  {
    path: 'packages/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/package-detail/package-detail.component').then(m => m.PackageDetailComponent)
  },
  {
    path: 'packages',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/packages/packages.component').then(m => m.PackagesComponent)
  },
  {
    path: 'custom-package/:token',
    loadComponent: () => import('./pages/custom-package-detail/custom-package-detail.component').then(m => m.CustomPackageDetailComponent)
  },
  {
    path: 'admin/custom-packages/:id',
    canActivate: [adminGuard],
    loadComponent: () => import('./pages/custom-package-detail/custom-package-detail.component').then(m => m.CustomPackageDetailComponent)
  },
  {
    path: 'super-admin/custom-packages/:id',
    canActivate: [superAdminGuard],
    loadComponent: () => import('./pages/custom-package-detail/custom-package-detail.component').then(m => m.CustomPackageDetailComponent)
  },
  {
    path: 'destinations',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/places/places.component').then(m => m.PlacesComponent)
  },
  {
    path: 'places',
    redirectTo: 'destinations',
    pathMatch: 'full'
  },
  {
    path: 'donate/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/donation-detail/donation-detail.component').then(m => m.DonationDetailComponent)
  },
  {
    path: 'donate',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/donate/donate.component').then(m => m.DonateComponent)
  },
  {
    path: 'admin/donations',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/donation-management/donation-management.component').then(m => m.DonationManagementComponent)
  },
  {
    path: 'super-admin/donations',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/donation-management/donation-management.component').then(m => m.DonationManagementComponent)
  },
  {
    path: 'donation-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/donation-management/donation-management.component').then(m => m.DonationManagementComponent)
  },
  {
    path: 'gallery-management',
    canActivate: [adminOrSuperAdminGuard],
    loadComponent: () => import('./pages/gallery-management/gallery-management.component').then(m => m.GalleryManagementComponent)
  },
  {
    path: 'gallery',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/gallery/gallery.component').then(m => m.GalleryComponent)
  },
  {
    path: 'gallery/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/gallery-detail/gallery-detail.component').then(m => m.GalleryDetailComponent)
  },
  {
    path: 'enquiry',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/enquiry/enquiry.component').then(m => m.EnquiryComponent)
  },
  {
    path: 'sevas/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/seva-detail/seva-detail.component').then(m => m.SevaDetailComponent)
  },
  {
    path: 'sevas',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/sevas/sevas.component').then(m => m.SevasComponent)
  },
  {
    path: 'crafts/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/craft-detail/craft-detail.component').then(m => m.CraftDetailComponent)
  },
  {
    path: 'articals/:id',
    redirectTo: 'crafts/:id',
    pathMatch: 'full'
  },
  {
    path: 'crafts',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/crafts/crafts.component').then(m => m.CraftsComponent)
  },
  {
    path: 'articals',
    redirectTo: 'crafts',
    pathMatch: 'full'
  },
  {
    path: 'services/accommodation',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/accommodation/accommodation.component').then(m => m.AccommodationComponent)
  },
  {
    path: 'services/transportation',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/transportation-enquiry/transportation-enquiry.component').then(m => m.TransportationEnquiryComponent)
  },
  {
    path: 'about',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'support',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/support/support.component').then(m => m.SupportComponent)
  },
  {
    path: 'testimonials/:id',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/testimonial-detail/testimonial-detail.component').then(m => m.TestimonialDetailComponent)
  },
  {
    path: 'testimonials',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/testimonials/testimonials.component').then(m => m.TestimonialsComponent)
  },
  {
    path: 'privacy-policy',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms-conditions',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent)
  },
  {
    path: 'refund-policy',
    canActivate: [nonPrivilegedGuard],
    loadComponent: () => import('./pages/refund-policy/refund-policy.component').then(m => m.RefundPolicyComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];
